import { useSetDocumentTitle } from 'hooks/useSetDocumentTitle';
import type { CmsApiPagePost } from 'modules/cms/api/types/CmsApiPage';
import { useCmsContentPageScrollHandler } from 'modules/cms/hooks/useCmsContentPageScrollHandler';

import { CmsPostPageBody } from './Body/CmsPostPageBody';
import { CmsPostPageLayout } from './Layout/CmsPostPageLayout';

type Props = {
  content: CmsApiPagePost;
};

export function CmsPostPage({ content }: Props) {
  useSetDocumentTitle(content.headTitle ?? content.title);
  useCmsContentPageScrollHandler();

  return (
    <CmsPostPageLayout content={content}>
      <CmsPostPageBody content={content} />
    </CmsPostPageLayout>
  );
}
